import { useQuery } from '@tanstack/react-query';
import { toast } from 'sonner';
import { portalApi } from '../services/portalApi';
import { queryKeys } from './queryKeys';
import { useApiMutation } from '../hooks/useApiMutation';

export function useAgentsQuery({ enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.agents,
    queryFn: portalApi.agents,
    select: (res) => res.agents || [],
    enabled
  });
}

export function useAssistantName() {
  const { data: agents = [] } = useAgentsQuery();
  return (agents.find((a) => a.status === 'active') || agents[0])?.name || 'Assistant';
}

// First name only, dropping any " — Company" suffix (e.g. "Millie — Flavin" -> "Millie").
export function useAgentShortName() {
  return String(useAssistantName()).split(/\s*—\s*/)[0].trim();
}

const saveAgent = async ({ id, ...changes }) => {
  const res = await portalApi.updateAgent(id, changes);
  if (res.warning) toast.warning(res.warning);
  return res;
};

export function useUpdateAgentMutation() {
  return useApiMutation({
    mutationFn: saveAgent,
    invalidate: [queryKeys.agents],
    success: 'Assistant saved',
    error: 'Could not save the assistant'
  });
}
